import React from 'react'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import HFQuantitiesGroup from 'components/HFInputs/HFQuantitiesGroup'
import styles from '../Dialog.module.sass'
import { TaskNeedsController } from 'controllers/TaskManager/TaskSubControllers/TaskNeedsController/TaskNeedsController'
import { TaskForwardingController } from 'controllers/TaskManager/TaskSubControllers/TaskForwardingController/TaskForwardingController'
import TaskPaymentsController from 'controllers/TaskManager/TaskSubControllers/TaskPaymentsController/TaskPaymentsController'
import TaskMedicalActsController from 'controllers/TaskManager/TaskSubControllers/TaskMedicalActsController/TaskMedicalActsController'
import TaskIntervenientsController from 'controllers/TaskManager/TaskSubControllers/TaskIntervenientsController/TaskIntervenientsController'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import HFTextInput from 'components/HFInputs/HFTextInput'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import InfoList from 'components/InfoList/InfoList'

export const SurgeryClinicalApprovalAdministrativeForm = (props) => {
	const { i18n } = useGlobal()
	const { data } = props
	const {
		requisitionDetails,
		requisition,
		outsideNetwork,
		districts,
		serviceProviders,
		isFromIsland,
	} = data

	return (
		<>
			<fieldset>
				<VStack>
					<h4>{i18n`Surgery data`}</h4>
					<InfoList
						items={requisitionDetails}
						orientation={'vertical'}
					/>
				</VStack>
			</fieldset>

			<TaskMedicalActsController requisition={requisition} />

			{requisition?.medicalActs && requisition?.medicalActs.length > 0 ? (
				<fieldset>
					<HStack gap='xsmall'>
						<h4>{i18n`Surgeries`}</h4>
						<h4 className={styles['counter']}>
							{requisition?.medicalActs?.length || 0}
						</h4>
					</HStack>
					<HFQuantitiesGroup
						name={'surgeries'}
						data={requisition?.medicalActs || []}
					/>
				</fieldset>
			) : null}

			<TaskIntervenientsController requisition={requisition} />

			<TaskForwardingController
				outsideNetwork={outsideNetwork}
				requisitionOutsideNetwork={requisition?.outsideNetwork}
				districts={districts}
				serviceProviders={serviceProviders}
				providerDescription={requisition?.providerDescription}
				districtName={requisition?.district?.name}
			/>

			{isFromIsland && (
				<TaskNeedsController
					isAdministrative={true}
					requisition={requisition}
				/>
			)}

			{data.requiresChargeAmount && <TaskPaymentsController />}

			<fieldset className={styles['observation-container']}>
				<ExpandableWidget
					className={styles['observation']}
					heading='h5'
					title={i18n`Administrative Observations`}
				>
					<HFTextInput
						name='administrativeObservation'
						placeholder={i18n`Administrative observation (optional)`}
						multiline={true}
						rows={5}
						noResize
					/>
				</ExpandableWidget>
			</fieldset>
		</>
	)
}
